export const isMedicare = (name?: string | null): boolean => {
  if (name == null) return false;

  return name.toLowerCase() === "medicare";
};
